import { render, staticRenderFns } from "./ValueProp.vue?vue&type=template&id=8901189a&scoped=true&"
import script from "./ValueProp.vue?vue&type=script&lang=js&"
export * from "./ValueProp.vue?vue&type=script&lang=js&"
import style0 from "./ValueProp.vue?vue&type=style&index=0&id=8901189a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8901189a",
  null
  
)

export default component.exports